import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/header.css";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import api from "../../utils/api";
import MenuItems from "../MenuItems";
const Header = () => {
  const navigate = useNavigate();

  const [showLoginModal, setShowLoginModal] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentUser, setCurrentUser] = useState("");

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const storedUser = sessionStorage.getItem("username");
    if (token && storedUser) {
      setIsAuthenticated(true);
      setCurrentUser(storedUser);
    }
  }, []);

  const toggleLoginModal = () => {
    if (!isAuthenticated) {
      setShowLoginModal(true);
      setError("");
    }
  };

  const handleLogin = async () => {
    try {
      const response = await api.post("/authenticate", {
        username,
        password,
      });

      const token = response.data?.id_token;
      if (token) {
        sessionStorage.setItem("token", token);
        sessionStorage.setItem("username", username);
        setIsAuthenticated(true);
        setCurrentUser(username);
        setShowLoginModal(false);
        setUsername("");
        setPassword("");
        setError("");
      } else {
        setError("Invalid response from server.");
      }
    } catch (err) {
      setError("Login failed. Please check your credentials.");
    }
  };

  const handleLogout = () => {
    sessionStorage.clear();
    setIsAuthenticated(false);
    setCurrentUser("");
    navigate("/");
  };

  return (
    <>
      <header className="header">
        <div className="header-left" onClick={() => navigate("/")}>
          Sahaj Gyan
        </div>

        {isAuthenticated && <MenuItems />}

        <div className="header-right">
          {isAuthenticated ? (
            <>
              <span className="username-label">{currentUser}</span>
              <button className="logout-btn" onClick={handleLogout}>Logout</button>
            </>
          ) : (
            <div className="login-icon-wrapper" onClick={toggleLoginModal}>
              <AccountCircleIcon className="avatar-icon" />
            </div>
          )}
        </div>
      </header>

      {showLoginModal && (
        <div className="modal-overlay">
          <div className="login-modal">
            <button className="close-btn" onClick={() => setShowLoginModal(false)}>✖</button>
            <h3>Login</h3>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button className="login-btn" onClick={handleLogin}>Submit</button>
            {error && <p className="error-text">{error}</p>}
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
